import { render, staticRenderFns } from "./agingRangeByCategory.vue?vue&type=template&id=ec3fdda6"
import script from "./agingRangeByCategory.vue?vue&type=script&lang=js"
export * from "./agingRangeByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports